var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_header"},[_c('span',{staticClass:"small"}),_c('span',{staticClass:"big"}),_c('span',{staticClass:"text"},[_vm._t("default",function(){return [_vm._v("页面标题")]})],2),_c('span',{staticClass:"big"}),_c('span',{staticClass:"small"})])
}
var staticRenderFns = []

export { render, staticRenderFns }